<template>
  <div>
    <el-container v-if="shop_id === 1068 || shop_id === 1085 || shop_id === 1 || shop_id === 18" style="width:100%;">
      <el-header>
        <el-radio-group v-model="type" style="margin-top 1%;">
          <el-radio-button label="mobileTheme">{{ generateCustomizeString('mobileTheme') }}</el-radio-button>
          <el-radio-button label="pcTheme">{{ generateCustomizeString('pcTheme') }}</el-radio-button>
        </el-radio-group>
        <span>{{ generateCustomizeString('themeOnlyApplyToHome') }}</span>
      </el-header>
      <el-main v-loading="loading">
        <!-- 移动端主题 start -->
        <el-row
          v-if="type === 'mobileTheme'"
          :gutter="20"
        >
          <el-col :span="8" v-for="theme in themes" :key="theme.id">
            <el-card class="box-card">
              <div class="theme-card">
                <span>{{ generateCustomizeString('theme') }} {{ theme.id }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="generateCustomizeString('clickToEnlargeImg')"
                  placement="top-end"
                >
                  <el-image
                    :src="theme.preview_img[0]"
                    class="preview-img"
                    fit="scale-down"
                    :preview-src-list="theme.preview_img"
                  >
                  </el-image>
                </el-tooltip>
                <div>
                  <!-- <el-button type="info" size="small">{{ generateCustomizeString('preview') }}</el-button> -->
                  <el-button
                    v-if="theme.id !== ui_template_id"
                    type="primary"
                    size="small"
                    @click="showConfirmDialog(theme.id)"
                  >
                    {{ generateCustomizeString('publish') }}
                  </el-button>
                  <el-button
                    v-else
                    type="primary"
                    size="small"
                    disabled
                  >
                    {{ generateCustomizeString('currentApplied') }}
                  </el-button>
                  <el-button
                    type="warning"
                    size="small"
                    v-if="theme.customizable"
                    @click="customizeTheme(theme.id)"
                  >
                   {{ generateCustomizeString('customization') }}
                  </el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <!-- 移动端主题 end -->

        <!-- PC端主题 start -->
        <el-row
          v-if="type === 'pcTheme'"
        >
          <div class="pc-customization-panel">
            <i class="el-icon-warning-outline"></i>&nbsp;
            {{ generateCustomizeString('pcCurrentlyNoTheme') }}
          </div>
        </el-row>
        <!-- PC端主题 end -->
      </el-main>
    </el-container>
    <!-- <el-container v-else>
      <h5>{{ generateCustomizeString('functionCurrentlyDisabled') }}</h5>
    </el-container> -->

    <!-- 应用主题确认框 start -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ generateCustomizeString('confirmToApplyTheme') }} {{ tmpThemeId }}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="setTheme">Confirm</el-button>
      </span>
    </el-dialog>
    <!-- 应用主题确认框 end -->
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { mapGetters } from 'vuex'
import request from '@/utils/request'

export default {
  name: 'UserInterfaceManagement',
  data() {
    return {
      loading: false,
      type: 'mobileTheme',
      dialogVisible: false,
      tmpThemeId: null,
      themes: [
        {
          id: 1,
          name: 'Theme 1',
          preview_img: ['https://img.nzmai.com.cn/JNK%20%E5%8F%AF%E5%8F%AF%E5%AE%B6_page-0001%20%281%29.jpg'],
          customizable: false
        },
        {
          id: 2,
          name: 'Theme 2',
          preview_img: ['https://img.nzmai.com.cn/ui3.jpeg'],
          customizable: false
        },
        {
          id: 3,
          name: 'Theme 3',
          preview_img: ['https://img.nzmai.com.cn/iemall_ui3-1.png'],
          customizable: true
        },
        {
          id: 4,
          name: 'Theme 4',
          preview_img: ['https://img.nzmai.com.cn/ui3.jpeg'],
          customizable: false
        },
        {
          id: 5,
          name: 'Theme 5',
          preview_img: ['https://img.nzmai.com.cn/ui3.jpeg'],
          customizable: false
        },
        {
          id: 6,
          name: 'Theme 6',
          preview_img: ['https://img.nzmai.com.cn/ui3.jpeg'],
          customizable: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'ui_template_id',
      'shop_id'
    ])
  },
  methods: {
    generateCustomizeString,
    showConfirmDialog(themeId) {
      this.tmpThemeId = themeId
      this.dialogVisible = true
    },
    setTheme() {
      this.dialogVisible = false
      this.loading = true
      const data = {}
      data['configs'] = {
        ui_template_id: this.tmpThemeId
      }
      request({
        url: 'basic',
        method: 'patch',
        data
      })
        .then((res) => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$store.dispatch('SetShopThemeId')
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    customizeTheme(themeId) {
      this.$router.push({
        name: 'ThemeCustomization',
        params: { themeId: themeId }
      })
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
  h5 {
    font-size: 30px;
    margin-left: 30%;
    margin-top: 10%;
  }
  .el-row {
    text-align: center;
  }
  .el-col {
    margin-bottom: 20px;
  }
  .theme-card {
    height: 32vh;
    span {
      float: left;
      font-weight: 500;
    }
  }
  .preview-img {
    margin: 0 auto;
    width: 95%;
    height: 85%;
    object-fit: contain;
    overflow-x: auto;
    white-space: nowrap;
  }
  .el-header {
    padding-top: 2%;
    span {
      color: red;
      font-size: 12px;
      margin-left: 30px;
    }
  }
  .pc-customization-panel {
    font-size: 20px;
    padding-top: 20%;
    i {
      color: #409EFF;
    }
  }
</style>
